function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "add-academics-modal-1-full-",
  transform: "translate(-269.000000, -594.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11-Copy"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-38",
  transform: "translate(24.000000, 550.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ios-add-circle",
  transform: "translate(245.000000, 44.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#7EC884",
  x: 0,
  y: 0,
  width: 34,
  height: 34,
  rx: 17
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1543726,21.8 L14.1543726,19.8792833 L11.3948289,19.8792833 C10.0077567,19.8792833 9.00030418,18.9332587 9.00030418,17.8080627 C9.00030418,16.5180291 9.93475285,15.6651736 11.3218251,15.6651736 C11.4313308,15.6651736 11.4897338,15.6006719 11.4824335,15.4860022 C11.3437262,13.4792833 12.7965019,12.6550952 14.4974905,13.1209406 C14.5923954,13.1496081 14.6653992,13.1281075 14.7092015,13.0421053 C15.3881369,11.7735722 16.4758935,10.9207167 18.154981,10.9207167 C20.2793916,10.9207167 21.8489734,12.5619261 21.9511787,14.5758119 C21.9803802,15.0488242 21.9365779,15.5218365 21.900076,15.887346 C21.8854753,15.9948488 21.9292776,16.0521837 22.0387833,16.0665174 C23.3893536,16.2600224 24.1996958,16.9838746 24.1996958,18.0947368 C24.1996958,19.1554311 23.3893536,19.8792833 22.0679848,19.8792833 L18.8558175,19.8792833 L18.8558175,21.8 L22.1628897,21.8 C24.4990114,21.8 26.2,20.3666293 26.2,18.281075 C26.2,16.6470325 25.316654,15.2853303 23.8273764,14.7119821 C23.820076,11.393729 21.3671483,9 18.1768821,9 C16.3006844,9 14.7603042,9.88868981 13.7601521,11.2718925 C11.876654,10.8777156 9.88365019,12.2179171 9.75224335,14.2604703 C8.04395437,14.6044793 7,16.0951848 7,17.8797312 C7,20.0512878 8.8469962,21.8 11.3875285,21.8 L14.1543726,21.8 Z M16.6,25 C17.0681223,25 17.431441,24.6003633 17.431441,24.1425976 L17.431441,17.6466848 L17.3126638,16.4550409 L17.7179039,17.0363306 L18.5423581,17.9082652 C18.689083,18.0608538 18.8777293,18.1553134 19.0873362,18.1553134 C19.4576419,18.1553134 19.8,17.8574024 19.8,17.4359673 C19.8,17.2179837 19.7231441,17.058129 19.5834061,16.9128065 L17.2637555,14.6312443 C17.0401747,14.4132607 16.8235808,14.3333333 16.6,14.3333333 C16.3764192,14.3333333 16.1598253,14.4132607 15.9362445,14.6312443 L13.6235808,16.9128065 C13.4768559,17.058129 13.4,17.2179837 13.4,17.4359673 C13.4,17.8574024 13.7353712,18.1553134 14.1126638,18.1553134 C14.3222707,18.1553134 14.510917,18.0608538 14.6576419,17.9082652 L15.4820961,17.0363306 L15.8873362,16.4550409 L15.768559,17.6466848 L15.768559,24.1425976 C15.768559,24.6003633 16.1318777,25 16.6,25 Z",
  id: "Icon",
  fill: "#FFFFFF",
  fillRule: "nonzero"
})))))));

var SvgFileUpload = function SvgFileUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/file-upload.d53b30ae.svg";
export { ForwardRef as ReactComponent };